import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateDecisionVariable(node, nodeFields, accept) {
    const { idField, nodeTypeField, decisionVariableField, outputField } = nodeFields;
    // decisionVariable is only for action nodes
    if (nodeTypeField?.nodeType?.value !== 'A')
        return;
    if (!decisionVariableField ||
        ast.isEmptyField(decisionVariableField?.decisionVariable)) {
        accept('error', "Missing required 'decisionVariable' field for this node.", {
            node: decisionVariableField || node,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.DECISION_VARIABLE,
            },
        });
    }
    else {
        // We do have a decision variable present
        // Get the list of variables from the output field and verify that it is
        // present there
        const decisionVariable = decisionVariableField?.decisionVariable?.value;
        let decisionVariableFound = false;
        const output = outputField?.output || [];
        for (const variable of output) {
            if (variable.value === decisionVariable) {
                decisionVariableFound = true;
            }
        }
        if (!decisionVariableFound) {
            accept('error', `Decision variable '${decisionVariable}' is not present in the output field.`, {
                node: decisionVariableField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.DECISION_VARIABLE,
                },
            });
        }
    }
}
//# sourceMappingURL=validate-decision-variable.js.map